import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  AtsTicketsOrderField,
  ExportTicketsJunctionWiseResult,
  ExportTicketsJunctionWiseVar,
  GetTicketsData,
  GetTicketsVars,
  TicketEdge,
  TicketsQueryType,
} from "../../../../../queries/types";
import {
  ExportTicketsJunctionWise,
  GetTickets,
} from "../../../../../queries/queries";
import { useLazyQuery } from "@apollo/client";
import {
  CustomModal,
  convertToTimeZone,
  ticketPriorityClassName,
  ticketStatusClassName,
  toInputStandardDate,
  toIsoDate,
  toStandardDate,
} from "../../../../../utils/UtilFunctions";
import {
  debouncedDelay,
  DEFAULT_TIME,
  emptyFunc,
  emptyMessage,
  FETCH_MORE_DATA,
  pollingMinutes,
  ROWS_PER_PAGE,
  ticketPriorirityOptions,
  TicketStatus,
  ticketStatusOptions,
} from "../../../../../utils/constants";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import {
  FlexForColumns,
  HEADER_TEXT_ALIGN,
  SLNO_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../../styles/Variables";

import {
  PriorityOptionsTypes,
  TicketStatusOptionsTypes,
  TableHeaderProps,
} from "../../../../../utils/types";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import {
  GridColDef,
  GridAlignment,
  GridColumnVisibilityModel,
  GridRenderCellParams,
} from "@mui/x-data-grid-pro";
import DownloadDoc from "../../../../../images/DownloadImage.svg";
import EyeWhite from "../../../../../images/EyeWhite.svg";
import Edit from "../../../../../images/EditProfile.svg";
import Input from "../../../../../stories/Input/Input";
import useLabels from "../../../../../customHooks/useLabels";
import SubsidiarySelect from "../../../../../customComponents/SubsidiarySelect";
import SiteSelect from "../../../../../customComponents/SiteSelect";
import JunctionsAutocomplete from "../../../../../customComponents/JunctionsAutocomplete";
import { FilterBarProps } from "../../maps/ticketdetails/TicketsRaisedList";
import ItemsAutocomplete from "../../../../../customComponents/ItemsAutocomplete";
import { Button } from "../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import useServerDateandTime from "../../../../../customHooks/useServerDateandTime";
import {
  ViewAssetStylesRaiseTicket,
  ViewModalStyles,
  WaiveOffModalStyles,
} from "../../../../../styles/CustomModalStyles";
import RaisedTicketDetails from "../../maps/ticketing/junctionDetails/raisedTickets/RaisedTicketDetails";
import MultiplePrioritySelect from "../../../../../customComponents/MultiplePrioritySelect";
import MultipleTicketStatusSelect from "../../../../../customComponents/MultipleTicketStatusSelect";
import CompaniesAutocomplete from "../../../customer/companies/CompaniesAutocomplete";
import { MapsContext } from "../../maps/context/context";
import { mapsPayloadType } from "../../maps/context/reducer";
import { TableType } from "../../../customer/companies/queries/types";
import Compare from "../../../../../images/Compare.svg";

import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import dayjs from "dayjs";
import { AssetDetailsPageFor } from "../../maps/ticketing/junctionDetails/raisedTickets/AssetDetails";
import {
  ExportTicketsResult,
  ExportTicketsVariables,
} from "../../maps/queries/types";
import { ExportTickets } from "../../maps/queries/queriers";
import {
  ExportTypes,
  Operation,
  PageFrom,
  TimeZone,
  empType,
} from "../../../../../utils/Enum.types";
import { getDownloadUrl } from "../../../../../utils/DownloadFile";
import SuppliersSelect from "../../purchase/purchaseorder/rfqtopo/components/SuppliersSelect";
import { responseType } from "../../../../../utils/formTypes";
import { LdgrQueryType } from "../../masters/supplier/queries/types";
import { TicketListProps } from "./TicketWiseIndex";
import Add from "../../../../../images/Add.svg";
import RaiseTicket from "./RaiseTicket";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import MessageModal from "../../../../../customComponents/MessageModal";
import EditTicket from "./edit/EditTicket";
import { AppContext } from "../../../../../context/context";
import LoadingModal from "../../../../pages/LoadingModal";
import { Title } from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import { useDebounce } from "../../../../../customHooks/useDebounce";
export enum TicketTablePageFor {
  REPORTS = "REPORTS",
  DASHBOARD = "DASHBOARD",
  MODAL = "MODAL",
}
export interface TicketTableProps extends TicketListProps {
  pageFor: TicketTablePageFor;
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  pageFrom?: PageFrom
}
const Table = ({ queryType, pageFor, setModalFlag,pageFrom }: TicketTableProps) => {
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [searchData, setSearchData] = useState<string>("");
  const debouncedSearch = useDebounce(searchData, debouncedDelay);
  const [tickets, setTickets] = useState<TicketEdge[]>([]);

  const { serverDate } = useServerDateandTime();
  const [viewDetails, setViewDetails] = useState(false);
  const [editDetails, setEditDetails] = useState(false);
  const [raiseTicket, setRaiseTicket] = useState(false);

  const [exportModal, setExportModal] = useState(false);
  const [exportFormat, setExportFormat] = useState<ExportTypes>(
    ExportTypes.EXCEL
  );
  const { Maps } = useAssetTableJson();
  const [statusSelected, setStatusSelected] = useState<
    TicketStatusOptionsTypes[]
  >([]);

  const [message, setMessage] = useState(emptyMessage);

  const [vendor, setVendor] = useState<responseType | null>(null);

  const [tableType, setTableType] = useState<TableType>(TableType.COMPANY);

  const [prioritySelected, setPrioritySelected] = useState<
    PriorityOptionsTypes[]
  >([]);

  const [Export] = useLazyQuery<ExportTicketsResult, ExportTicketsVariables>(
    ExportTickets,
    {
      onError: (e) => {
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE,
        });
      },
    }
  );

  const { company_id, customer_id, sub_id, siteID, junctionID } =
    useUrlParams();
  const { user_details } = useLoggedInUserDetails();
  const { state, dispatch } = useContext(MapsContext);
  const { state: globalState } = useContext(AppContext);
  const navigate = useNavigate();
  const [filterFormData, setFilterFormData] = useState<FilterBarProps>({
    asset: 0,
    assetStatus: "",
    priority: "",
    searchData: "",
    ticketReason: "",
    ticketStatus: "",
    date: "",
    subsidiary: 0,
    endDate: "",
    fromDate: "",
  });
  const [GetTicket, { data, loading, fetchMore }] = useLazyQuery<
    GetTicketsData,
    GetTicketsVars
  >(GetTickets, {
    pollInterval: pageFrom && pageFrom === PageFrom.DASHBOARD ? pollingMinutes : undefined,
  });

  const [exportTicketsJunctionWise] = useLazyQuery<
    ExportTicketsJunctionWiseResult,
    ExportTicketsJunctionWiseVar
  >(ExportTicketsJunctionWise);

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetTickets.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCustomer) => {
          const filteredStudent = tickets.find(
            (ticket) => ticket.node.id === newCustomer.node.id
          );
          if (filteredStudent) {
            return {
              ...newCustomer,
              node: {
                ...newCustomer.node,
              },
            };
          }
          return newCustomer;
        });

        setTickets(updatedNewData);
      } else {
        setTickets(newData);
      }

      setEndCursor(data.GetTickets.pageInfo.endCursor);
      setHasNextPage(data.GetTickets.pageInfo.hasNextPage);
    } // eslint-disable-next-line
  }, [loading, data]);

  const rows = useMemo(() => {
    return data
      ? data.GetTickets.edges.map(({ node }, index) => ({
          id: index + 1,
          logNo: node.ticketNo,
          asset: node.item.desc,
          asset_slno: node.itemDetails.prodSerialNo,
          ticket_date:
            toStandardDate(node.ticketDate) !== toStandardDate(DEFAULT_TIME)
              ? convertToTimeZone(TimeZone.Asia_Kolkata, node.ticketDate)
                  .timeAndDate
              : "-",
          subsidiary: node.subsidiaryDetails.name,
          subsidiary_site: node.site.name,
          junction: node.junction.name,
          ticket_reason: node.reason,
          status: node.status,
          maintained_by: node.vendorDetails.desc,
          attachments: "",
          priority: node.priority,
          ticket_status: node.status,
          ticket_id: node.id,
          asset_id: node.itemDetails.id,
          tableId:
            node.tableLevel === TableType.ASSET
              ? node.itemDetails.id
              : node.junctionID,
          tableLevel: node.tableLevel,
          closedDuration: node.closedDuration,
          company: node.company.name,
          poleNum: node.poleNum,

          closedDate:
            toStandardDate(node.closedDate) !== toStandardDate(DEFAULT_TIME)
              ? convertToTimeZone(TimeZone.Asia_Kolkata, node.closedDate)
                  .timeAndDate
              : "-",
        }))
      : [];
  }, [data]);

  const handleScroll = () => {
    if (hasNextPage && !loading) {
      fetchMore({
        variables: {
          first: FETCH_MORE_DATA,
          after: endCursor,
        },
        updateQuery: (prevResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prevResult;

          const newEdges = fetchMoreResult.GetTickets.edges;
          const pageInfo = fetchMoreResult.GetTickets.pageInfo;

          setEndCursor(pageInfo.endCursor);
          setHasNextPage(pageInfo.hasNextPage);

          const duplicateCheck = prevResult.GetTickets
            ? prevResult.GetTickets.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              )
            : [];

          if (duplicateCheck.length > 0) return prevResult;

          return {
            GetTickets: {
              edges: [...tickets, ...newEdges],
              pageInfo,
              totalCount: data ? data.GetTickets.totalCount! : 0,
            },
          };
        },
      });
    }
  };

  useEffect(() => {
    if (
      customer_id &&
      ((vendor && queryType === TicketsQueryType.SLA_REPORT) ||
        queryType === TicketsQueryType.ALL)
    ) {
      GetTicket({
        variables: {
          after: null,
          first: ROWS_PER_PAGE,
          name: debouncedSearch,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsTicketsOrderField.TICKET_NO,
          },

          companyID: company_id
            ? company_id
            : state.company
            ? state.company.node.id
            : 0,
          customerID: customer_id,
          subsidiaryID: sub_id
            ? sub_id
            : state.subsidary
            ? state.subsidary.node.id
            : 0,
          reason: filterFormData.ticketReason
            ? filterFormData.ticketReason
            : "",
          startDate: filterFormData.fromDate
            ? toIsoDate(filterFormData.fromDate)
            : undefined,
          endDate: filterFormData.endDate
            ? toIsoDate(filterFormData.endDate)
            : undefined,
          input: {
            itemID: filterFormData.asset,
            ldgrID: vendor ? vendor.value : 0,
            stckCategoryID: 0,
            stckGroupID: 0,
            stckManufacturerID: 0,
            stckSubCategoryID: 0,
            stckUomID: 0,
            query_type: queryType,
            itemDetailsID: 0,
            status: statusSelected.map((status) => status.value),
            priority: prioritySelected.map((priority) => priority.value),
            empID: user_details.id!,
          },
          siteID: siteID ? siteID : state.site ? state.site.value : 0,
          junctionID: junctionID
            ? junctionID
            : state.junction
            ? state.junction.node.id
            : 0,
        },
      });
    }
  }, [
    GetTicket,
    debouncedSearch,
    company_id,
    customer_id,
    sub_id,
    state.subsidary,
    state.company,
    state.junction,
    state.site,
    filterFormData.priority,
    filterFormData.ticketStatus,
    filterFormData.asset,
    filterFormData.ticketReason,
    prioritySelected,
    statusSelected,
    user_details.id,
    filterFormData.fromDate,
    filterFormData.endDate,
    vendor,
    queryType,
    junctionID,
    siteID,
  ]);

  const dynamicHeaders: TableHeaderProps[] = Maps.RaisedTicketDetails.map(
    (header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      renderCell: (params) => {
        if (header.field === "actions") {
          return (
            <>
              <button
                className="tkt-raised-list__tableblock--view"
                onClick={() => {
                  dispatch({
                    type: mapsPayloadType.ASSET_TYPE_ID,
                    payload: {
                      assetTypeId: params.row.tableId,
                    },
                  });
                  dispatch({
                    type: mapsPayloadType.TICKET,
                    payload: {
                      ticketId: params.row.ticket_id,
                    },
                  });
                  setTableType(params.row.tableLevel);
                  setViewDetails(!viewDetails);
                }}
              >
                View Details <img src={EyeWhite} alt="" />
              </button>
            </>
          );
        } else if (header.field === "priority") {
          return (
            <>
              <div
                className={ticketPriorityClassName(params.row.priority)}
                style={{ margin: "auto", height: 25 }}
              >
                {params.row.priority}
              </div>
            </>
          );
        } else if (header.field === "attachments") {
          return (
            <>
              <div className={`tkt-raised-list__tableblock--attachments`}>
                {params.row.attachments} <img src={DownloadDoc} alt="" />
              </div>
            </>
          );
        } else if (header.field === "ticket_status") {
          return (
            <>
              <span
                className={ticketStatusClassName(params.row.ticket_status)}
                style={{ margin: "auto" }}
              >
                {params.row.ticket_status}
              </span>
            </>
          );
        } else return params.value;
      },
    })
  );
  const columns: GridColDef[] = [
    ...dynamicHeaders,
    ...(globalState.empSubType === empType.HELP_DESK &&
    (pageFor === TicketTablePageFor.DASHBOARD ||
      pageFor === TicketTablePageFor.MODAL)
      ? [
          {
            headerName: "Edit Ticket",
            field: "edit_ticket",
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.SUB_DESC,
            renderCell: (params: GridRenderCellParams) => {
              if (
                params.row.ticket_status === TicketStatus.OPEN ||
                params.row.ticket_status === TicketStatus.ASSIGNED
              ) {
                return (
                  <>
                    <img
                      src={Edit}
                      alt=""
                      onClick={() => {
                        dispatch({
                          type: mapsPayloadType.TICKET,
                          payload: {
                            ticketId: params.row.ticket_id,
                          },
                        });

                        dispatch({
                          type: mapsPayloadType.RAISE_TICKET_LEVEL,
                          payload: {
                            raiseTicketLevel: params.row.tableLevel,
                          },
                        });

                        setEditDetails(!editDetails);
                      }}
                    />
                  </>
                );
              }
            },
          },
        ]
      : []),
  ];
  const {
    itemLabel,
    companyLabel,
    subsidiaryLabel,
    subsidiarySiteLabel,
    junctionLabel,
    ledgerLabel,
  } = useLabels();

  useEffect(() => {
    if (serverDate) {
      setFilterFormData({
        ...filterFormData,
        fromDate: filterFormData.fromDate
          ? filterFormData.fromDate
          : toInputStandardDate(serverDate),
        endDate: filterFormData.endDate
          ? filterFormData.endDate
          : toInputStandardDate(serverDate),
      });
    }
  }, [serverDate]);

  useEffect(() => {
    setStatusSelected(
      filterFormData.ticketStatus
        ? ticketStatusOptions.filter(
            (item) => item.value === filterFormData.ticketStatus
          )
        : []
    );
  }, [ticketStatusOptions, filterFormData.ticketStatus]);

  useEffect(() => {
    if (filterFormData.priority) {
      setPrioritySelected(
        ticketPriorirityOptions.filter(
          (item) => item.value === filterFormData.priority
        )
      );
    }
  }, [ticketPriorirityOptions, filterFormData.priority]);

  const handleExport = async () => {
    if (customer_id) {
      Export({
        variables: {
          companyID: state.companyId,
          customerID: customer_id,
          startDate: filterFormData.fromDate
            ? toIsoDate(filterFormData.fromDate)
            : undefined,
          endDate: filterFormData.endDate
            ? toIsoDate(filterFormData.endDate)
            : undefined,
          siteID: 0,
          subsidiaryID: sub_id ? sub_id : 0,

          input: {
            itemID: filterFormData.asset,
            ldgrID: vendor ? vendor.value : 0,
            stckCategoryID: 0,
            stckGroupID: 0,
            stckManufacturerID: 0,
            stckSubCategoryID: 0,
            stckUomID: 0,
            query_type: queryType,
            itemDetailsID: 0,
            status: statusSelected.map(({ value }) => value),
            priority: prioritySelected.map(({ value }) => value),
            empID: user_details.id!,
          },
          format: exportFormat,
        },
      }).then(async ({ data }) => {
        if (data && data.ExportTickets) {
          const res = await getDownloadUrl(data.ExportTickets, true);
          if (res) {
            setMessage({
              flag: true,
              message: "Downloading...",
              operation: Operation.CREATE,
            });
          }
        }
      });
      setExportModal(!exportModal);
    }
  };
  const [columnVisibilityModel, setColumnVisibilityModel] =
    React.useState<GridColumnVisibilityModel>({
      id: true,
      ticket_date: true,
      logNo: true,
      company: false,
      subsidiary: false,
      subsidiary_site: false,
      asset: false,
      poleNum: false,
      ticket_reason: false,
      maintained_by: false,
      resolvedDate: false,
      asset_slno: false,
      closedDate: true,
      ticket_status: true,
      priority: true,
      resolvedDuration: false,
      closedDuration: false,
      actions: true,
    });
  useEffect(() => {
    const savedVisibilityModel = localStorage.getItem(
      ColumnVisibilityFor.TICKET_LIST_REPORT
    );
    if (savedVisibilityModel) {
      setColumnVisibilityModel(JSON.parse(savedVisibilityModel));
    }
  }, []);

  const handleDownload = async () => {
    try {
      if (customer_id && vendor) {
        const { data, errors } = await exportTicketsJunctionWise({
          variables: {
            customerID: customer_id,
            startDate: filterFormData.fromDate
              ? toIsoDate(filterFormData.fromDate)
              : undefined,
            endDate: filterFormData.endDate
              ? toIsoDate(filterFormData.endDate)
              : undefined,
            ldgrID: vendor ? vendor.value : 0,
          },
        });

        if (data && data.ExportTicketsJunctionWise) {
          const res = await getDownloadUrl(
            data.ExportTicketsJunctionWise,
            true
          );
          if (res) {
            setMessage({
              flag: true,
              message: "Downloading...",
              operation: Operation.CREATE,
            });
          }
        } else {
          setMessage({
            flag: true,
            message: "Failed downloading file",
            operation: Operation.NONE,
          });
        }

        if (errors && errors.length > 0) {
          setMessage({
            flag: true,
            message: errors[0].message,
            operation: Operation.NONE,
          });
        }
      }
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    }
  };

  return (
    <div className="asset-reports__right--block">
      <div className="asset-reports__right--filters row g-0">
        <div className="col-2">
          <Input
            id="data_search"
            placeholder="Search..."
            onChange={(e) => {
              setSearchData(e.target.value);
            }}
          />{" "}
        </div>
        {!company_id ? (
          <div className="col-2">
            <CompaniesAutocomplete
              onChange={(newValue) => {
                if (newValue) {
                  dispatch({
                    type: mapsPayloadType.COMPANY,
                    payload: {
                      company: newValue,
                    },
                  });
                } else {
                  dispatch({
                    type: mapsPayloadType.COMPANY,
                    payload: {
                      company: null,
                    },
                  });
                  dispatch({
                    type: mapsPayloadType.SUBSIDARY,
                    payload: {
                      subsidary: null,
                    },
                  });
                  dispatch({
                    type: mapsPayloadType.SITE,
                    payload: {
                      site: null,
                    },
                  });
                  dispatch({
                    type: mapsPayloadType.JUNCTION,
                    payload: {
                      junction: null,
                    },
                  });
                }
              }}
              onKeyDown={emptyFunc}
              label={companyLabel}
              value={state.company ? state.company.node.id : 0}
            />
          </div>
        ) : null}

        {!sub_id ? (
          <div className="col-2">
            <SubsidiarySelect
              onChange={(newValue) => {
                if (newValue) {
                  dispatch({
                    type: mapsPayloadType.SUBSIDARY,
                    payload: {
                      subsidary: newValue,
                    },
                  });
                } else {
                  dispatch({
                    type: mapsPayloadType.SUBSIDARY,
                    payload: {
                      subsidary: null,
                    },
                  });
                  dispatch({
                    type: mapsPayloadType.SITE,
                    payload: {
                      site: null,
                    },
                  });
                  dispatch({
                    type: mapsPayloadType.JUNCTION,
                    payload: {
                      junction: null,
                    },
                  });
                }
              }}
              label={subsidiaryLabel}
              companyID={
                company_id
                  ? company_id
                  : state.company
                  ? state.company.node.id
                  : 0
              }
              onKeyDown={emptyFunc}
              value={state.subsidary ? state.subsidary.node.id : 0}
            />
          </div>
        ) : null}
        {!siteID ? (
          <div className="col-2">
            <SiteSelect
              onChange={(newValue) => {
                if (newValue) {
                  dispatch({
                    type: mapsPayloadType.SITE,
                    payload: {
                      site: newValue,
                    },
                  });
                } else {
                  dispatch({
                    type: mapsPayloadType.SITE,
                    payload: {
                      site: null,
                    },
                  });
                  dispatch({
                    type: mapsPayloadType.JUNCTION,
                    payload: {
                      junction: null,
                    },
                  });
                }
              }}
              companyId={
                company_id
                  ? company_id
                  : state.company
                  ? state.company.node.id
                  : 0
              }
              subsidiaryId={
                sub_id ? sub_id : state.subsidary ? state.subsidary.node.id : 0
              }
              onKeyDown={emptyFunc}
              value={state.site ? state.site.value : 0}
              label={subsidiarySiteLabel}
            />
          </div>
        ) : null}
        {!junctionID ? (
          <div className="col-2">
            <JunctionsAutocomplete
              onChange={(newValue) => {
                if (newValue) {
                  dispatch({
                    type: mapsPayloadType.JUNCTION,
                    payload: {
                      junction: newValue,
                    },
                  });
                } else {
                  dispatch({
                    type: mapsPayloadType.JUNCTION,
                    payload: {
                      junction: null,
                    },
                  });
                }
              }}
              companyID={
                company_id
                  ? company_id
                  : state.company
                  ? state.company.node.id
                  : 0
              }
              subsidiaryID={
                sub_id ? sub_id : state.subsidary ? state.subsidary.node.id : 0
              }
              siteID={state.site ? state.site.value : 0}
              onKeyDown={emptyFunc}
              value={state.junction ? state.junction.node.id : 0}
              label={junctionLabel}
            />
          </div>
        ) : null}

        <div className="col">
          <ItemsAutocomplete
            onChange={(newValue) => {
              if (newValue) {
                setFilterFormData({
                  ...filterFormData,
                  asset: newValue.value,
                });
              } else {
                setFilterFormData({
                  ...filterFormData,
                  asset: 0,
                });
              }
            }}
            onKeyDown={emptyFunc}
            value={filterFormData.asset}
            label={itemLabel}
            placeholder=""
          />
        </div>
      </div>
      <div className="asset-reports__right--filters-2 row g-0">
        <div className="col-2 asset-reports__right--multiple-select">
          <MultiplePrioritySelect
            onChange={(newValue) => {
              setPrioritySelected(newValue);
            }}
            onKeyDown={emptyFunc}
            autoCompleteValue={prioritySelected}
            handleClear={emptyFunc}
            label="Ticket Priority"
          />
        </div>
        <div className="col-2 asset-reports__right--multiple-select">
          <MultipleTicketStatusSelect
            onChange={(newValue) => {
              setStatusSelected(newValue);
            }}
            onKeyDown={emptyFunc}
            value={statusSelected}
            handleClear={emptyFunc}
            label="Ticket Status"
          />
        </div>
        {globalState.empSubType !== empType.VENDOR_MANAGER && (
          <div className="col-2">
            <SuppliersSelect
              onChange={(newValue) => {
                if (newValue) setVendor(newValue);
                else setVendor(null);
              }}
              onKeyDown={emptyFunc}
              value={vendor ? vendor.value : 0}
              label={ledgerLabel}
              input={{
                itemID: 0,
                query_type: LdgrQueryType.ALL,
                tableLevel: TableType.CUSTOMER,
              }}
            />
          </div>
        )}
        <div className="col ">
          <div className="tkt-raised-list__select--flex">
            <TextField
              label="From date"
              className="asset-reports__right--textfield"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              type="date"
              onChange={(e) => {
                if (
                  dayjs(e.target.value).isAfter(
                    dayjs(filterFormData.endDate)
                  ) ||
                  dayjs(e.target.value).isSame(dayjs(filterFormData.endDate))
                ) {
                  return;
                }
                setFilterFormData({
                  ...filterFormData,
                  fromDate: e.target.value,
                });
              }}
              value={filterFormData.fromDate}
            />

            <img src={Compare} alt="" />
            <TextField
              label="To date"
              className="asset-reports__right--textfield"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              type="date"
              onChange={(e) => {
                if (
                  dayjs(e.target.value).isBefore(
                    dayjs(filterFormData.fromDate)
                  ) ||
                  dayjs(e.target.value).isSame(dayjs(filterFormData.fromDate))
                ) {
                  return;
                }
                setFilterFormData({
                  ...filterFormData,
                  endDate: e.target.value,
                });
              }}
              value={filterFormData.endDate}
            />
          </div>
        </div>
        {pageFor === TicketTablePageFor.REPORTS ? null : (
          <div className="col flex-end">
            <Button
              onClick={() => {
                setRaiseTicket(!raiseTicket);
              }}
            >
              <img src={Add} alt="/" />
              Raise New Ticket
            </Button>
          </div>
        )}
      </div>
      <div className="asset-reports__right--block--tickets">
        {queryType === TicketsQueryType.SLA_REPORT && vendor === null ? (
          <b className="nodata">Please select a vendor to proceed</b>
        ) : (
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            // onCellClick={(params) => {
            //   if (params.field === "actions") {
            //     dispatch({
            //       type: mapsPayloadType.TICKET,
            //       payload: {
            //         ticketId: params.row.ticket_id,
            //       },
            //     });
            //     // if (params.row.status === TicketStatus.CLOSED) {
            //     //   setAssetdetails({
            //     //     flag: true,
            //     //     itemId: params.row.asset_id,
            //     //   });
            //     // } else {
            //     //   setRaisedTicketModal({
            //     //     flag: true,
            //     //     itemId: params.row.asset_id,
            //     //   });
            //     // }
            //   }
            // }}
            onCellClick={(params) => {
              if (params.field === "logNo") {
                dispatch({
                  type: mapsPayloadType.ASSET_TYPE_ID,
                  payload: {
                    assetTypeId: params.row.tableId,
                  },
                });
                dispatch({
                  type: mapsPayloadType.TICKET,
                  payload: {
                    ticketId: params.row.ticket_id,
                  },
                });
                setTableType(params.row.tableLevel);
                setViewDetails(!viewDetails);
              }
            }}
            disableRowSelectionOnClick
            hideFooter
            initialState={{
              pinnedColumns: {
                left: ["id", "ticket_no", "asset", "asset_id"],
                right: ["actions", "edit_ticket"],
              },
            }}
            onRowsScrollEnd={() => {
              handleScroll();
            }}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
          />
        )}
      </div>
      {pageFor === TicketTablePageFor.REPORTS ? (
        <div className="asset-reports__right--block--footer">
          <div>
            <Button
              mode="excel"
              onClick={() => setExportModal(!exportModal)}
              disabled={!tickets.length}
            >
              Export
            </Button>
            <Button
              mode="excel"
              onClick={handleDownload}
              disabled={vendor?.value ? false : true}
            >
              Junction Wise Excel
            </Button>
            <Button mode="back" onClick={() => navigate(-1)} />
          </div>
          <div className="overall-total-count">
            Total Tickets <b>{data ? data.GetTickets.totalCount : 0}</b>
          </div>
        </div>
      ) : pageFor === TicketTablePageFor.MODAL ? (
        <div className="asset-reports__right--block--footer">
          <>
            <Button mode="cancel" onClick={() => setModalFlag(false)} />
          </>
          <div className="overall-total-count">
            Total Tickets <b>{data ? data.GetTickets.totalCount : 0}</b>
          </div>
        </div>
      ) : null}
      <CustomModal
        style={ViewModalStyles}
        isOpen={viewDetails}
        onRequestClose={() => setViewDetails(!viewDetails)}
        contentComponent={
          <RaisedTicketDetails
            setModalFlag={() => setViewDetails(!viewDetails)}
            pageFor={AssetDetailsPageFor.REPORTS}
            assetType={tableType}
          />
        }
      />

      <CustomModal
        isOpen={raiseTicket}
        style={ViewAssetStylesRaiseTicket}
        onRequestClose={() => setRaiseTicket(!raiseTicket)}
        contentComponent={<RaiseTicket setModalFlag={setRaiseTicket} />}
      />

      <CustomModal
        style={ViewModalStyles}
        isOpen={editDetails}
        onRequestClose={() => setEditDetails(!editDetails)}
        contentComponent={<EditTicket setModalFlag={setEditDetails} />}
      />
      <CustomModal
        style={WaiveOffModalStyles}
        isOpen={exportModal}
        onRequestClose={() => setExportModal(!exportModal)}
        contentComponent={
          <>
            <div className="choose-export-type">
              <div className="choose-export-type__title">
                <Title>Choose Excel Or Pdf</Title>
                <img
                  src={Close}
                  alt=""
                  onClick={() => setExportModal(!exportModal)}
                />
              </div>
              <div className="choose-export-type__block">
                <FormControl>
                  <RadioGroup
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setExportFormat(e.target.value as ExportTypes)
                    }
                    defaultValue={ExportTypes.EXCEL}
                  >
                    <FormControlLabel
                      control={<Radio />}
                      label="Excel"
                      value={ExportTypes.EXCEL}
                    />
                    <FormControlLabel
                      value={ExportTypes.PDF}
                      control={<Radio />}
                      label="Pdf"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <Button mode="save" onClick={handleExport} />
              <Button
                mode="cancel"
                onClick={() => setExportModal(!exportModal)}
              />
            </div>
          </>
        }
      />

      <MessageModal
        handleClose={() => setMessage(emptyMessage)}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal flag={!searchData && loading} />
    </div>
  );
};

export default Table;
